import { Stack } from '@etg/wings';
import { type Dispatch, type SetStateAction } from 'react';
import type { TripCampaignsType, TripsType, TripType } from '../../../models';
import ResultTripCard from './ResultTripCard';
import type { RESULT_TRIP_TYPE } from './constants';

const getTripCampaignForFlight = (
  trip: NonNullable<TripType>,
  tripCampaigns?: TripCampaignsType,
) => {
  if (!tripCampaigns) {
    return null;
  }

  return tripCampaigns.find((tripCampaign) => tripCampaign?.selectionKey === trip.selectionKey);
};

interface ResultTripCardsProps {
  resultTripType?: RESULT_TRIP_TYPE;
  setIsItineraryDrawerSelfTransferModalOpen: Dispatch<SetStateAction<boolean>>;
  setIsSelfTransferModalOpen: Dispatch<SetStateAction<boolean>>;
  tripCampaigns?: TripCampaignsType;
  trips: TripsType;
}

export const ResultTripCards = ({
  resultTripType,
  setIsItineraryDrawerSelfTransferModalOpen,
  setIsSelfTransferModalOpen,
  tripCampaigns,
  trips,
}: ResultTripCardsProps) => {
  return (
    <Stack>
      {trips.map((trip: TripType) => {
        if (!trip) {
          return null;
        }

        return (
          <ResultTripCard
            key={trip.id}
            resultTripType={resultTripType}
            setIsItineraryDrawerSelfTransferModalOpen={setIsItineraryDrawerSelfTransferModalOpen}
            setIsSelfTransferModalOpen={setIsSelfTransferModalOpen}
            trip={trip}
            tripCampaign={getTripCampaignForFlight(trip, tripCampaigns)}
          />
        );
      })}
    </Stack>
  );
};
